import { Link } from 'react-router-dom';

const CommunityHighlights = () => {
  const highlights = [
    {
      id: 1,
      icon: 'ri-quill-pen-line',
      title: 'Submit Your Story',
      description: 'Share your original horror tales with our community. All genres welcome, from psychological terror to cosmic dread.',
      link: '/submission',
      color: 'red'
    },
    {
      id: 2,
      icon: 'ri-discuss-line',
      title: 'Join Discussions',
      description: 'Connect with fellow horror enthusiasts. Share theories, feedback, and fan art in our active forums.',
      link: '/community',
      color: 'red'
    }
  ];

  return (
    <section className="py-20 px-4 bg-[#0a0a0a]">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-red-600 mb-4 font-['Cinzel']">
            Join the Community
          </h2>
          <p className="text-gray-400 text-lg font-['Crimson_Text']">
            Become part of the darkness
          </p>
        </div>

        <div className="flex flex-col md:flex-row justify-center gap-8 mb-16">
          {highlights.map((item, index) => (
            <div
              key={item.id}
              className="group relative w-full md:w-96 bg-gradient-to-br from-[#1a0a0a] to-[#0f0f0f] border border-red-900/20 rounded-lg p-8 hover:border-red-600/50 transition-all duration-300 hover:shadow-2xl hover:shadow-red-900/30"
              style={{
                animation: `fadeInUp 0.6s ease-out ${index * 0.15}s both`,
              }}
            >
              {/* Icon */}
              <div className="mb-6 w-16 h-16 flex items-center justify-center bg-red-600/10 rounded-lg group-hover:bg-red-600/20 transition-colors">
                <i className={`${item.icon} text-4xl text-red-500 group-hover:scale-110 transition-transform`}></i>
              </div>

              {/* Content */}
              <h3 className="text-2xl font-bold text-white mb-3 font-['Cinzel'] group-hover:text-red-500 transition-colors">
                {item.title}
              </h3>

              <p className="text-gray-400 mb-6 font-['Crimson_Text'] leading-relaxed">
                {item.description}
              </p>

              <Link
                to={item.link}
                className="inline-flex items-center text-red-500 hover:text-red-400 font-['Crimson_Text'] font-semibold transition-colors cursor-pointer"
              >
                Learn More
                <i className="ri-arrow-right-line ml-2 group-hover:translate-x-2 transition-transform"></i>
              </Link>
            </div>
          ))}
        </div>

        {/* Call to Action */}
        <div className="relative bg-gradient-to-r from-red-900/20 to-red-600/20 border border-red-900/30 rounded-lg p-12 text-center overflow-hidden">
          <div className="absolute inset-0 opacity-10">
            <div className="absolute inset-0 bg-gradient-to-br from-red-600 to-transparent"></div>
          </div>

          <div className="relative z-10">
            <h3 className="text-3xl md:text-4xl font-bold text-white mb-4 font-['Cinzel']">
              Ready to Share Your Nightmares?
            </h3>
            <p className="text-gray-300 text-lg mb-8 font-['Crimson_Text'] max-w-2xl mx-auto">
              Create an account to submit stories, vote on your favorites, and connect with a community of horror enthusiasts.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Link
                to="/register"
                className="px-8 py-3 bg-red-600 hover:bg-red-700 text-white font-semibold rounded-lg transition-all duration-300 shadow-lg shadow-red-900/30 hover:shadow-red-900/50 font-['Crimson_Text'] whitespace-nowrap cursor-pointer"
              >
                Create Account
              </Link>
              <Link
                to="/login"
                className="px-8 py-3 bg-gray-800 hover:bg-gray-700 text-white font-semibold rounded-lg transition-all duration-300 shadow-lg shadow-black/30 hover:shadow-black/50 font-['Crimson_Text'] whitespace-nowrap cursor-pointer"
              >
                Sign In
              </Link>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </section>
  );
};

export default CommunityHighlights;